import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type INavMenuLabelProps = IContainerProps & {
  children: React.ReactNode;
};

const styles = stylex.create({
  host: {
    paddingLeft: '1rem',
    paddingRight: '0.75rem',
    paddingTop: '0.5rem',
    color: colorSchemeTokens.secondary,
  },
});

export const NavMenuLabel: React.FC<INavMenuLabelProps> = ({
  sx,
  children,
}) => <div {...stylex.props(styles.host, sx)}>{children}</div>;
